import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=5d78c3f5"
import script from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports